import { createContext } from "react";
import { Notification, NotificationsSummary } from "./types";

const summaryInitialValue: NotificationsSummary = {
  has_pending: false,
  pending_count: 0,
  unread_count: 0,
  pending_acceptance_count: 0,
};

export type NotificationsContextProps = {
  notifications: Notification[];
  summary: NotificationsSummary;
  hasPending: boolean;
  unreadCount: number;
  isDrawerOpen: boolean;

  openDrawer: () => void;
  closeDrawer: () => void;

  setNotifications: (data: Notification[]) => void;
  refreshSummary: () => Promise<void>;
  loadNotifications: () => Promise<Notification[]>;
  markAsViewed: (id: string) => Promise<void>;
  markAllAsViewed: (ids: string[]) => Promise<void>;
  acceptNotification: (id: string) => Promise<void>;
};

export const notificationsContextInitialValues: NotificationsContextProps = {
  notifications: [],
  summary: summaryInitialValue,
  hasPending: false,
  unreadCount: 0,
  isDrawerOpen: false,

  openDrawer: () => null,
  closeDrawer: () => null,

  setNotifications: () => null,
  refreshSummary: () => Promise.resolve(),
  loadNotifications: () => Promise.resolve([]),
  markAsViewed: () => Promise.resolve(),
  markAllAsViewed: () => Promise.resolve(),
  acceptNotification: () => Promise.resolve(),
};

export const NotificationsContext = createContext<NotificationsContextProps>(
  notificationsContextInitialValues,
);
